<template>
  <div class="tnc-wrapper">
    <h2><span style="font-size: 16pt">Term &amp; Conditions</span></h2>
    <h4>
      <strong><span style="font-size: 12pt">General Rules</span></strong>
    </h4>
    <ol>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Our website is solely restricted to individuals of legal age as determined in
            the jurisdiction in which the
            individual resides.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Our website holds no responsibility for any national laws, federal laws or
            international laws infringed by
            any users using our website.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Users are responsible for their own actions and are bound by their own
            countries&apos; laws, which includes
            state laws or legal issues.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">All agents are responsible for their respective members&apos; accounts, and
            shall honor all confirmed bets
            submitted by them.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Agents are not partners of Our website. Therefore Our website holds no
            responsibility for any discrepancies
            or disputes between Players and Agents.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">It is the user&apos;s responsibility to guard his/her User ID and Password
            from unauthorized usage. If the
            user&apos;s User ID and Password are stolen or compromised, it is the user&apos;s responsibility to contact
            his/her agent immediately. The agent will then change the user&apos;s User ID and Password for
            him/her.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">In the event of a stolen User ID and Password, the user is responsible for
            their respective accounts and
            will honor all confirmed bets submitted.</span>
        </p>
      </li>
    </ol>
    <h4>
      <strong><span style="font-size: 12pt">Gaming Rules</span></strong>
    </h4>
    <ol>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p><span style="font-size: 10.5pt">The game results decided by Our website will be final and binding.</span></p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">In all cases of dispute, both management of Our website and the player must
            agree that Our website
            transaction log database will serve as the final arbiter in the dispute. All disputes must be lodged within
            the day of that match outcome is determined. No claims will be honored after the match day.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">The Player is solely responsible for verifying the accuracy of all their
            account transactions.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Please be sure to review your bets for any mistakes, errors or omissions
            before submitting them over the
            computer. Once a bet is accepted over the computer, it cannot be changed or cancelled.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">We reserve the right to freeze or cancel any customer&apos;s account found in
            breach of these Terms and
            Conditions, engaging in fraudulent activities, trespassing, attacking, falsifying, corrupting standard
            rules, or involved in syndicate betting, with all resulting account balances being frozen and forfeited
            without prior notice.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">We reserve the right to void or cancel any bet or ticket found to be
            associated with syndicate betting, coordinated betting, collusion, fraud, system abuse, exploitation of
            technical errors, incorrect odds, or any other attempt to gain an unfair advantage. Any related winnings may
            be reversed, and the relevant account may be suspended or terminated.</span>
        </p>
      </li>
    </ol>
    <h4>
      <strong><span style="font-size: 12pt">Limits and Liabilities</span></strong>
    </h4>
    <ol>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Without prejudice to the generality of the foregoing, Our website will not be
            liable to any person in the
            event of sabotage, force majeure, and/or for the events of failure or damage or destruction to Our website
            central computer system or records or any part thereof, or delays, losses, errors, omissions or any others
            thereof resulting from failure of any telecommunications or any data transmission system, or any delay
            resulting in non-receipt of any entry for a particular race.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Our website will not be liable for any loss as a result of an act of God, in
            an outbreak of hostilities,
            riot, civil unrest, act of terrorism, act of government or authority (including refusal or revocation of any
            license or consent), fire explosion, flood, theft, malicious damage, strike, lock-out and industrial action
            of any kind.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">In the event of network connection, communications, system or human errors
            that causes bet related issues
            such as double bets being accepted, bets not able to be confirmed, place bets after the game started, etc.
            We reserve the right in the event of such errors to address it on a case by case basis and also to take any
            other action to correct such errors. We will not have any liability to you or to any third party in respect
            of such errors. If you have experienced such errors and continue to bet without reporting to your upline,
            you will be held responsible and honor all win/loss results if the errors happen again.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">These Rules and Regulations constitute the entire agreement and understanding
            between the parties.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">If there is any discrepancy between the English language version of these
            Rules and Regulations and any
            other language version, the English language version supersedes the other languages and is deemed correct
            and valid.</span>
        </p>
      </li>
    </ol>
    <BurgerMenu v-if="isMobile" />
  </div>
</template>
<script>
  import BurgerMenu from '@/components/burger-menu.vue';
  import { isMobile } from 'mobile-device-detect';
  export default {
    components: {
      BurgerMenu,
    },
    data: () => {
      return {
        isMobile,
      };
    },
  };
</script>
<style lang="scss" scoped>
  .tnc-wrapper {
    padding: 16px 24px;
    box-sizing: border-box;
    height: calc(100% - 56px);
    overflow-y: auto;
  }

  strong,
  h2,
  h4 {
    font-weight: 600;
  }
</style>
